import * as React from "react";
import { Button, useDataProvider, SelectArrayInput } from "react-admin";
import { Container, Grid, Paper } from "@material-ui/core";
import { Form } from "react-final-form";
import SearchIcon from "@material-ui/icons/Search";
import { useState } from "react";
import { PeriodSelect } from "../../../Components/PeriodSelect";
import { ThyFleetTypes } from "../../../../src/Constants/Constant";

const NffReportFilter = ({ filterParams, setFilterParams, user }: any) => {
  const dataProvider = useDataProvider();
  const [customerCodeList, setCustomerCodeList] = useState<any>([]);

  React.useEffect(() => {
    GetCustomerCodeList();
  }, []);

  const GetCustomerCodeList = () => {
    dataProvider
      .getList("customers", {
        pagination: { page: 1, perPage: 1000 },
        sort: { field: "customerName", order: "ASC" },
        filter: {},
      })
      .then(response => {
        // Create a map to deduplicate by customerCode
        const customerMap = new Map();

        response?.data?.forEach(item => {
          if (!customerMap.has(item.customerCode)) {
            customerMap.set(item.customerCode, {
              customerCode: item.customerCode,
              customerName: item.customerCode,
            });
          }
        });

        // Convert map to array and add THY-C at the beginning
        const customerCodes = Array.from(customerMap.values());
        setCustomerCodeList(customerCodes);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const onSubmit = values => {
    setFilterParams(values);
  };

  return (
    <Container maxWidth="xl">
      <Form
        onSubmit={onSubmit}
        initialValues={filterParams || {}}
        render={({ handleSubmit, submitting }) => (
          <form onSubmit={handleSubmit} noValidate>
            <Paper style={{ padding: 10 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  {!user?.isCustomer && (
                    <SelectArrayInput
                      source="customer__in"
                      optionValue="customerCode"
                      optionText="customerName"
                      fullWidth
                      variant="outlined"
                      choices={customerCodeList}
                      label="Customer"
                      allowEmpty
                    />
                  )}
                  <SelectArrayInput
                    source="fleetType__in"
                    optionValue="value"
                    optionText="type"
                    fullWidth
                    variant="outlined"
                    choices={ThyFleetTypes}
                    label="Fleet Type"
                    allowEmpty
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <PeriodSelect source="startDate" fullWidth variant="outlined" label="Request Date From" />
                  <PeriodSelect source="endDate" fullWidth variant="outlined" label="Request Date To" />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    disabled={submitting}
                    label="Search"
                    size="large"
                    startIcon={<SearchIcon />}
                    style={{ marginTop: 6 }}
                  />
                </Grid>
              </Grid>
            </Paper>
          </form>
        )}
      />
    </Container>
  );
};

export default NffReportFilter;
